module.exports = __webpack_public_path__ + "img/Glow-Wild-2020.eca2f105.jpg";